export default __webpack_public_path__ + "static/media/reception.a2a561c1.png";